export default __webpack_public_path__ + "static/Unity-4c58ff899d83c273adc5c1f2b9447a72.png";